import { inject } from 'mobx-react'
import { OptionsObject } from 'notistack'
import * as React from 'react'
import { Navigate } from 'react-router-dom'
import { IStores } from '../../Stores'

interface IRedirectWithErrorMessageProps {
  messageId: string
  message: string
  redirectTo: string
  sendNotification?: (key: string, message: string, options?: OptionsObject) => void
}

class RedirectWithErrorMessage extends React.Component<IRedirectWithErrorMessageProps> {
  public componentDidMount() {
    const { messageId, message, sendNotification } = this.props
    sendNotification!(messageId, message, {
      variant: 'error',
    })
  }

  public render() {
    return <Navigate to={this.props.redirectTo} replace />
  }
}

const InjectedRedirectWithErrorMessage = inject<
  IStores,
  IRedirectWithErrorMessageProps,
  Partial<IRedirectWithErrorMessageProps>,
  any
>((stores: IStores) => ({
  sendNotification: stores.notifications.sendNotification,
}))(RedirectWithErrorMessage)

export default InjectedRedirectWithErrorMessage
